module.exports = __webpack_public_path__ + "RobotoMedium.b157f77652afe5d17833.woff";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoMedium.woff
// module id = ../../../../../src/fonts/RobotoMedium.woff
// module chunks = 3